import axios from "axios";
import {
  API_MAX_CONTENT_LENGTH,
  API_TIMEOUT_LIMIT,
  MS_GRAPH_BASE_URL,
} from "../../helpers/constants";

const msGraphAxiosInstance = axios.create({
  baseURL: MS_GRAPH_BASE_URL,
  timeout: API_TIMEOUT_LIMIT,
  maxContentLength: API_MAX_CONTENT_LENGTH,
});

msGraphAxiosInstance.interceptors.request.use(
  (request) => {
    const token = sessionStorage.getItem("AccessToken");

    if (!!token) {
      request.headers.Authorization = `Bearer ${token}`;
    }
    return request;
  },
  (error) => {
    return Promise.reject(error);
  },
);

msGraphAxiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default msGraphAxiosInstance;
